import WidgetContext from 'embed_v2/components/Context'
import useDebounce from 'embed_v2/hooks/useDebounce'
import { useState, useEffect, useCallback, useContext } from 'preact/hooks'
import { getStylesFn } from 'core/helpers/styles'
import { ElementInputOptions } from 'core/types/element/element_input'
import optionsPropTypes from 'PropsSpec'
import CommonInput from './common/Input'

const extractStyles = getStylesFn(['paddingTop', 'paddingRight', 'paddingBottom', 'paddingLeft'], {
  width: '100%',
  height: '100%'
})

const getKey = (options: ElementInputOptions) => {
  if (options.type === 'custom') {
    return options.key
  }
  return options.type
}

const getType = (options: ElementInputOptions) => {
  switch (options.type) {
    case 'custom':
      return 'text'
    case 'phone':
      return 'tel'
    default:
      return options.type
  }
}

const getAutoComplete = (options: ElementInputOptions) => {
  switch (options.type) {
    case 'custom':
      return 'off'
    case 'phone':
      return 'tel'
    default:
      return options.type
  }
}

type Props = {
  options: ElementInputOptions
}

const Input = (props: Props) => {
  const { viewer, setViewerField, notification } = useContext(WidgetContext)
  const { options } = props
  const type = getType(options)
  const key = getKey(options)
  const autoComplete = getAutoComplete(options)
  const errors = notification.errors[key]

  const [value, setValue] = useState(viewer[key] || '')

  useEffect(() => {
    setValue(viewer[key] || '')
  }, [viewer[key]])

  const debouncedChangeHandler = useDebounce(setViewerField)

  const onChange = useCallback((val: string) => {
    setValue(val)
    debouncedChangeHandler(key, val)
  }, [])

  const styles = extractStyles(options)

  if (typeof value !== 'string') return null

  return (
    <div style={styles} className="wf_reset wf_field wf_field_input">
      <CommonInput
        type={type}
        value={value}
        name={autoComplete === 'off' ? options.key : autoComplete}
        autoComplete={autoComplete}
        onChange={onChange}
        options={options.input}
        placeholder={options.label}
        errorText={errors}
      />
    </div>
  )
}

Input.propTypes = {
  options: optionsPropTypes('input')
}

export default Input
